import { render } from "./comprehensiveAnalysis.vue?vue&type=template&id=4354a518&scoped=true"
import script from "./comprehensiveAnalysis.vue?vue&type=script&lang=js"
export * from "./comprehensiveAnalysis.vue?vue&type=script&lang=js"

import "./comprehensiveAnalysis.vue?vue&type=style&index=0&id=4354a518&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4354a518"]])

export default __exports__